import { render, staticRenderFns } from "./TightIntegration.vue?vue&type=template&id=89197d80&scoped=true&"
import script from "./TightIntegration.vue?vue&type=script&lang=ts&"
export * from "./TightIntegration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89197d80",
  null
  
)

export default component.exports